import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconChevronTriangleUpMedium"><Path d="M11.1412 7.86978C11.6551 7.38202 12.4883 7.41678 12.9566 7.97427L17.1333 12.9469C17.8164 13.7602 17.2384 15.0006 16.1763 15.0006H7.82279C6.76109 15.0004 6.1832 13.7601 6.86576 12.9469L11.0425 7.97427L11.1412 7.86978Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpMedium;
